export const RECOMMENDATION_SERVICE = "RecommendationService";
